import './styles.css'
import { registerSW } from 'virtual:pwa-register'
import { doneScreen } from './screens/done'
import { homeScreen } from './screens/home'
import { settingsScreen } from './screens/settings'
import { signScreen } from './screens/sign'
import { navigate, route, startRouter } from './router'
import { toast } from './ui/dom'

route(/^\/$/, () => homeScreen())
route(/^\/sign\/(.+)$/, ([id]) => signScreen(id ?? ''))
route(/^\/done\/(.+)$/, ([id]) => doneScreen(id ?? ''))
route(/^\/settings$/, () => settingsScreen())

const mount = document.getElementById('app')
if (mount) startRouter(mount)

// Warn before a reload throws away a half-filled form. The draft is in memory
// on purpose, so there is nothing to restore afterwards.
window.addEventListener('beforeunload', (event) => {
  if (window.location.hash.startsWith('#/sign')) {
    event.preventDefault()
    event.returnValue = ''
  }
})

const updateSW = registerSW({
  onNeedRefresh() {
    toast('A new version is ready. It will be used next time you open the app.')
  },
  onOfflineReady() {
    toast('Ready to work offline.')
  },
})
void updateSW

// A bad hash from a stale bookmark should land on the home screen, not nowhere.
if (!window.location.hash) navigate('/')
